import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";

import Select from 'react-select';

class AuctionVehicleAddModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      vehicleBrands: [],
      vehicleModels: [],
      vehicleModelYears: [],
      vehicleEquipments: [],
      vehicleEquipmentInfo: {},

      title: '',
      vehicleBrandId: 0,
      vehicleModelId: 0,
      vehicleEquipmentId: 0,
      year: '',
      details: {
        km: 0,
        plateNumber: '',
        color: '',
        fuelType: '',
        transmissionType: '',
        tractionType: '',
        engineCapacity: '',
        engineNumber: '',
        chassisNumber: '',
        registrationType: '',
        registrationCode: '',
        authorizationCertificateNumber: '',
        hasDublicateKeys: false
      },
      damageHistory: [],
      appraisalResult: {
        parts: {
          frontBumper: 'original',
          frontHood: 'original',
          roof: 'original',
          frontRightMudguard: 'original',
          rearRightMudguard: 'original',
          frontLeftMudguard: 'original',
          rearLeftMudguard: 'original',
          rearHood: 'original',
          rearBumper: 'original',
          rearLeftDoor: 'original',
          frontLeftDoor: 'original',
          rearRightDoor: 'original',
          frontRightDoor: 'original'
        },
        comment: ''
      },
      comment: '',
      soldStatus: 0,

      transmissions: [{type: 'Manuel'}, {type: 'Yarı Otomatik'}, {type: 'Otomatik'}],
      tractions: [{type: 'Önden Çekiş'}, {type: 'Arkadan İtiş'}, {type: '4X4'}],
      colors: [
        { id: 1, name: 'Altın' },
        { id: 2, name: 'Beyaz' },
        { id: 3, name: 'Bej' },
        { id: 4, name: 'Bordo' },
        { id: 5, name: 'Füme' },
        { id: 6, name: 'Gri' },
        { id: 7, name: 'Gümüş' },
        { id: 8, name: 'İnci Beyazı' },
        { id: 9, name: 'Kahverengi' },
        { id: 10, name: 'Kırmızı' },
        { id: 11, name: 'Lacivert' },
        { id: 12, name: 'Mavi' },
        { id: 13, name: 'Mor' },
        { id: 14, name: 'Sarı' },
        { id: 15, name: 'Siyah' },
        { id: 16, name: 'Şampanya' },
        { id: 17, name: 'Turuncu' },
        { id: 18, name: 'Turkuaz' },
        { id: 19, name: 'Yeşil' }
      ],
      registrationTypes: [
        { id: 1, name: 'Otomobil' },
        { id: 2, name: 'Arazi, SUV & Pickup' },
        { id: 3, name: 'Minivan & Panelvan' },
        { id: 4, name: 'Elektrikli' },
        { id: 5, name: 'Minibüs & Midibüs' },
        { id: 6, name: 'Otobüs' },
        { id: 7, name: 'Kamyon & Kamyonet' },
        { id: 8, name: 'Çekici' },
        { id: 9, name: 'Oto Kurtarıcı & Taşıyıcı' },
        { id: 10, name: 'Motosiklet' },
        { id: 11, name: 'ATV' },
        { id: 12, name: 'UTV' },
        { id: 13, name: 'Karavan' },
      ],
      fuelTypes: [{type: 'Benzin'}, {type: 'Dizel'}, {type: 'Benzin & LPG'}, {type: 'Elektrik'}, {type: 'Hibrit'}, {type: 'Elektrik & Hibrit'}, {type: 'Benzin & Hibrit'}],
      partsStatus: [{id: 'original', name: 'Orijinal'}, {id: 'replaced', name: 'Değişmiş'}, {id: 'painted', name: 'Boyalı'}, {id: 'localPainted', name: 'Lokal Boyalı'}, {id: 'plastic', name: 'Plastik Aksan'}]
    };

    this.inputRef = React.createRef();
  }

  componentDidMount() {
    this.getVehicleBrands()
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getVehicleBrands() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleBrands/tr?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200:
          this.setState({isLoading: false, vehicleBrands: responseData.vehicleBrands})
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/expertises'))
        break;
        default:
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        break;
      }
    }, () =>swal({ dangerMode: true, icon: "error", title: "Bağlantı Hatası", text: "Lütfen internet bağlantınızı kontrol ediniz.", buttons: "Yeniden Dene",}).then(() => this.getMyAppointmentsDetail()));
  }

  getModels(vehicleBrandId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModels/tr/' + vehicleBrandId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleBrandId: vehicleBrandId, vehicleModelId: '', vehicleModels: responseData.vehicleModels});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getYears(vehicleModelId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModelYears/tr/' + vehicleModelId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleModelId: vehicleModelId, vehicleModelYears: responseData.vehicleModelYears});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getVehicleEquipments(vehicleModelId, year) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleEquipments/tr/' + vehicleModelId + '/' + year + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleModelId: vehicleModelId, year: year, vehicleEquipments: responseData.vehicleEquipments});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getVehicleEquipmentInfo(id) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleEquipmentDetails/tr/' + id + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleEquipmentInfo: responseData.vehicleEquipmentInfo});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveAuctionVehicleOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const requestOptions = {
      method: 'POST',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({title: this.state.title, vehicleBrandId: this.state.vehicleBrandId, vehicleModelId: this.state.vehicleModelId, year: this.state.year, vehicleEquipmentId: this.state.vehicleEquipmentId, year: this.state.year,
        details: this.state.details, damageHistory: this.state.damageHistory, appraisalResult: this.state.appraisalResult, comment: this.state.comment, soldStatus: this.state.soldStatus})
    };

    fetch(config.restApi + 'auctionVehicle/tr', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'Araç sisteme başarıyla eklendi.',
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/auctionVehicleEdit?id=' + responseData.auctionVehicleId));
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  handleStatusChange = (value) => {
    this.setState({ soldStatus: value });
  };

  handleKeyChange = (value) => {
    this.setState((prevState) => ({ details: { ...prevState.details, hasDublicateKeys: value }}));
  };

  selectedBrandOnChange = (selectedBrand) => {
    const vehicleBrandId = selectedBrand ? selectedBrand.value : '';
    if (vehicleBrandId) {
      this.getModels(vehicleBrandId);
    } else {
      this.setState({ vehicleBrandId: '', year: '', vehicleModelId: '', vehicleEquipmentId: '', vehicleModels: [], vehicleModelYears: [], vehicleEquipments: [] });
      return;
    }
  
    this.setState({ vehicleBrandId: vehicleBrandId, vehicleModelId: '', year: '', vehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
  };
  
  selectedModelOnChange = (selectedModel) => {
    const vehicleModelId = selectedModel ? selectedModel.value : '';

    if (vehicleModelId) {
      this.getYears(vehicleModelId);
    } else {
      this.setState({ vehicleModelId: '', year: '', vehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
      return;
    }

    this.setState({ vehicleModelId: vehicleModelId, year: '', vehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
  };

  selectedVariantOnChange = (selectedVariant) => {
    const vehicleEquipmentId = selectedVariant ? selectedVariant.value : '';
    if (vehicleEquipmentId) {
      this.getVehicleEquipmentInfo(vehicleEquipmentId);
    } else {
      this.setState({ vehicleEquipmentId: vehicleEquipmentId });
      return;
    }
    this.setState({ vehicleEquipmentId: vehicleEquipmentId });
  };

  selectedColorOnChange = (selectedColor) => {
    const colorName = selectedColor ? selectedColor.search : ''
    this.setState(prevState => ({details: {...prevState.details, color: colorName}}))
  }

  selectedYearOnChange = (selectedYear) => {

    const year = selectedYear ? selectedYear.search : ''

    if (year) {
      this.getVehicleEquipments(this.state.vehicleModelId, year);
    } else {
      this.setState({ year: '', vehicleEquipmentId: '', vehicleEquipments: [] });
      return;
    }

    this.setState({ year: parseInt(year), vehicleEquipmentId: '', vehicleEquipments: [] });
  }

  selectedRegistrationTypeOnChange = (selectedColor) => {
    const registrationTypes = selectedColor ? selectedColor.search : ''
    this.setState(prevState => ({details: {...prevState.details, registrationType: registrationTypes}}))
  }

  handleChange = (event) => {
    const input = event.target;
    const value = input.value;
    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;

    const upperCaseValue = value.toUpperCase();
    this.setState({ title: upperCaseValue }, () => {
      if (this.inputRef.current) {
        this.inputRef.current.setSelectionRange(selectionStart, selectionEnd);
      }
    });
  }

  render() {

    const selectedBrandsOptions = [
      {value: '', label: 'Seçiniz' }, ...this.state.vehicleBrands.map((brandInfo) => ({
        value: brandInfo.id,
        label: `${brandInfo.name}`,
        search: brandInfo.name
      }))
    ];

    const selectedModelsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModels.map((modelInfo) => ({
        value: modelInfo.id,
        label: `${modelInfo.name}`,
        search: modelInfo.name
      }))
    ];

    const selectedVariantsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleEquipments.map((variantInfo) => ({
        value: variantInfo.id,
        label: `${variantInfo.name}`,
        search: variantInfo.name
      }))
    ];

    const selectedColorsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.colors.map((colorInfo) => ({
        value: colorInfo.id,
        label: `${colorInfo.name}`,
        search: colorInfo.name
      }))
    ];

    const selectedYearsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModelYears.map((yearInfo) => ({
        value: yearInfo.year,
        label: `${yearInfo.year}`,
        search: yearInfo.year
      }))
    ];

    const selectedRegistrationTypeOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.registrationTypes.map((registrationTypeInfo) => ({
        value: registrationTypeInfo.id,
        label: `${registrationTypeInfo.name}`,
        search: registrationTypeInfo.name
      }))
    ];

    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between text-darkblue pr-2">
              <h4 className="text-darkblue">Araç Ekle</h4>
              <button className="btn bg-orange text-white" onClick={this.saveAuctionVehicleOnClick} title="Kaydet"><i className="fa fa-save"></i></button>
            </div>
            <div className="row">
              <div className="col">
                <div className="ibox">
                  <div className="ibox-content text-darkblue">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>Marka<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedBrandOnChange}
                              options={selectedBrandsOptions}
                              isClearable={true}
                              defaultValue={selectedBrandsOptions.find((brand) => brand.value === this.state.vehicleBrandId) || selectedBrandsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedBrandsOptions.find((brand) => brand.value === this.state.vehicleBrandId)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Model<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.vehicleModels.length === 0}
                              onChange={this.selectedModelOnChange}
                              options={selectedModelsOptions}
                              isClearable={true}
                              defaultValue={selectedModelsOptions.find((model) => model.value === this.state.vehicleModelId) || selectedModelsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedModelsOptions.find((model) => model.value === this.state.vehicleModelId)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Araç Yılı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.vehicleModelYears.length === 0}
                              onChange={this.selectedYearOnChange}
                              options={selectedYearsOptions}
                              isClearable={true}
                              defaultValue={selectedYearsOptions.find((year) => year.value === this.state.year) || selectedYearsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedYearsOptions.find((year) => year.value === this.state.year)}
                              /* filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              } */
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Donanım<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.vehicleEquipments.length === 0}
                              onChange={this.selectedVariantOnChange}
                              options={selectedVariantsOptions}
                              isClearable={true}
                              defaultValue={selectedVariantsOptions.find((variant) => variant.value === this.state.vehicleEquipmentId) || selectedVariantsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedVariantsOptions.find((variant) => variant.value === this.state.vehicleEquipmentId)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          {
                            this.state.vehicleEquipmentInfo &&
                            this.state.vehicleEquipmentInfo.details &&
                            Array.isArray(this.state.vehicleEquipmentInfo.details.specs) &&
                            this.state.vehicleEquipmentInfo.details.specs.length > 0 ? (
                              <div className="col-12">
                                <div>
                                  <div className="row">
                                    {this.state.vehicleEquipmentInfo.details.specs.map((group, groupIndex) => (
                                      <div className="col-12 my-3" key={`spec-group-${groupIndex}`}>
                                        <h4 className="d-flex text-properties font-bold text-orange px-2">{group.group}</h4>
                                        <div className="row">
                                          {group.items.map((item, itemIndex) => (
                                            <div className="col-md-6 mb-2" key={`spec-item-${itemIndex}`}>
                                              <div className="d-flex align-items-center flex-row text-properties">
                                                <span className="d-flex properties-width text-left p-2">
                                                  <i className="fa fa-check text-green d-flex align-items-center mr-1"></i>
                                                  {item.label}: {item.value}
                                                </span>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="text-center m-3">Donanım Özelliği Bulunamadı.</div>
                            )
                          }
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <h5><strong>Başlık<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-control-sm form-input mb-1" ref={this.inputRef} onChange={this.handleChange} placeholder="Başlık" type="text" value={this.state.title} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>KM<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input
                              className="form-control form-input mb-1"
                              onChange={event => {
                                const value = event.target.value.replace(/[^0-9]/g, ""); // sadece sayı al
                                const parsedValue = parseInt(value || 0, 10);

                                this.setState(prevState => ({
                                  details: {
                                    ...prevState.details,
                                    km: isNaN(parsedValue) ? "" : parsedValue
                                  }
                                }));
                              }}
                              placeholder="KM"
                              type="text"
                              value={
                                this.state.details.km
                                  ? new Intl.NumberFormat("tr-TR").format(this.state.details.km) // 12.345 şeklinde gösterir
                                  : ""
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Plaka<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event =>  this.setState(prevState => ({ details: { ...prevState.details, plateNumber: event.target.value.replace(/\s/g, '').toUpperCase()}}))} placeholder="Plaka" type="text" value={this.state.details.plateNumber} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Araç Rengi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedColorOnChange}
                              options={selectedColorsOptions}
                              isClearable={true}
                              defaultValue={selectedColorsOptions.find((color) => color.value === this.state.details.color) || selectedColorsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedColorsOptions.find((color) => color.value === this.state.details.color)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Yakıt Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Yakıt Tipi" onChange={event => this.setState(prevState => ({details: {...prevState.details, fuelType: event.target.value}}))} value={this.state.details.fuelType}>
                              <option value="" disabled>Yakıt Tipi</option>
                              {this.state.fuelTypes.map((fuelType, index) =>
                                <option key={index} value={fuelType.type}>{fuelType.type}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Vites Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Vites Tipi" onChange={event => this.setState(prevState => ({details: {...prevState.details, transmissionType: event.target.value}}))} value={this.state.details.transmissionType}>
                              <option value="" disabled>Vites Tipi</option>
                              {this.state.transmissions.map((transmission, index) =>
                                <option key={index} value={transmission.type}>{transmission.type}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Çekiş Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Çekiş Tipi" onChange={event => this.setState(prevState => ({details: {...prevState.details, tractionType: event.target.value}}))} value={this.state.details.tractionType}>
                              <option value="" disabled>Çekiş Tipi</option>
                              {this.state.tractions.map((traction, index) =>
                                <option key={index} value={traction.type}>{traction.type}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Motor Hacmi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({details: {...prevState.details, engineCapacity: event.target.value}}))} placeholder="Motor Hacmi" type="text" value={this.state.details.engineCapacity} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Motor No<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({details: {...prevState.details, engineNumber: event.target.value.toUpperCase()}}))} placeholder="Motor No" type="text" value={this.state.details.engineNumber} />
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Şasi No<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({details: {...prevState.details, chassisNumber: event.target.value.toUpperCase()}}))} placeholder="Şasi No" type="text" value={this.state.details.chassisNumber} />
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Ruhsat Cinsi (Otomobil, Kamyon vb.)<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedRegistrationTypeOnChange}
                              options={selectedRegistrationTypeOptions}
                              isClearable={true}
                              defaultValue={selectedRegistrationTypeOptions.find((registrationType) => registrationType.search === this.state.details.registrationType) || selectedRegistrationTypeOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedRegistrationTypeOptions.find((registrationType) => registrationType.search === this.state.details.registrationType)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ruhsat Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({details: {...prevState.details, registrationCode: event.target.value.toUpperCase()}}))} placeholder="Ruhsat Tipi" type="text" value={this.state.details.registrationCode} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Yetki Belge No<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({details: {...prevState.details, authorizationCertificateNumber: event.target.value}}))} placeholder="Yetki Belge No" type="text" value={this.state.details.authorizationCertificateNumber} />
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Açıklama<strong className="text-danger ml-1">*</strong></strong></h5>
                            <textarea className="form-control form-control-sm form-input mb-1" onChange={event => this.setState({comment: event.target.value})} placeholder="Açıklama" type="text" value={this.state.comment} />
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Satış Durumu<strong className="text-danger ml-1">*</strong></strong></h5>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.soldStatus === 1} id="radioDefault1" name="radioDefault" onChange={() => this.handleStatusChange(1)} type="radio" />
                              <label className="form-check-label" htmlFor="radioDefault1">Satıldı</label>
                            </div>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.soldStatus === 0} id="radioDefault2" name="radioDefault" onChange={() => this.handleStatusChange(0)} type="radio" />
                              <label className="form-check-label" htmlFor="radioDefault2">Satılmadı</label>
                            </div>
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Yedek Anahtar Var Mı?<strong className="text-danger ml-1">*</strong></strong></h5>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.details.hasDublicateKeys === true} id="hasDublicateKeys1" name="hasDublicateKeys" onChange={() => this.handleKeyChange(true)} type="radio" />
                              <label className="form-check-label" htmlFor="hasDublicateKeys1">Evet</label>
                            </div>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.details.hasDublicateKeys === false} id="hasDublicateKeys2" name="hasDublicateKeys" onChange={() => this.handleKeyChange(false)} type="radio" />
                              <label className="form-check-label" htmlFor="hasDublicateKeys2">Hayır</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4 className="text-darkblue mt-2">Ekspertiz</h4>
                    <hr />
                    <div className="row">
                      <div className="col-md-6">
                        <h5><strong>Ön Tampon<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Ön Tampon" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, frontBumper: event.target.value }}}))} value={this.state.appraisalResult?.parts?.frontBumper || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Ön Sol Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Ön Sol Çamurluk" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, frontLeftMudguard: event.target.value }}}))} value={this.state.appraisalResult?.parts?.frontLeftMudguard || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Ön Kaput<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Ön Kaput" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, frontHood: event.target.value }}}))} value={this.state.appraisalResult?.parts?.frontHood || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                        <div className="col-md-6">
                          <h5><strong>Ön Sol Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                          <select className="form-control b-r-sm m-b mr-2" name="Ön Sol Kapı" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, frontLeftDoor: event.target.value }}}))} value={this.state.appraisalResult?.parts?.frontLeftDoor || 'original'}>
                            {this.state.partsStatus.map((part, index) =>
                              <option key={index} value={part.id}>{part.name}</option>
                            )}
                          </select>
                        </div>
                      <div className="col-md-6">
                        <h5><strong>Tavan<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Tavan" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, roof: event.target.value }}}))} value={this.state.appraisalResult?.parts?.roof || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Arka Sol Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Sol Kapı" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, rearLeftDoor: event.target.value }}}))} value={this.state.appraisalResult?.parts?.rearLeftDoor || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Ön Sağ Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Ön Sağ Çamurluk" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, frontRightMudguard: event.target.value }}}))} value={this.state.appraisalResult?.parts?.frontRightMudguard || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Arka Sol Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Sol Çamurluk" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, rearLeftMudguard: event.target.value }}}))} value={this.state.appraisalResult?.parts?.rearLeftMudguard || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Ön Sağ Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Sağ Kapı" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, frontRightDoor: event.target.value }}}))} value={this.state.appraisalResult?.parts?.frontRightDoor || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Arka Kaput<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Kaput" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, rearHood: event.target.value }}}))} value={this.state.appraisalResult?.parts?.rearHood || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Arka Sağ Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Sağ Kapı" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, rearRightDoor: event.target.value }}}))} value={this.state.appraisalResult?.parts?.rearRightDoor || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Arka Tampon<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Tampon" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, rearBumper: event.target.value }}}))} value={this.state.appraisalResult?.parts?.rearBumper || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <h5><strong>Arka Sağ Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                        <select className="form-control b-r-sm m-b mr-2" name="Arka Sağ Çamurluk" onChange={event => this.setState(prevState => ({ appraisalResult: { ...prevState.appraisalResult, parts: { ...prevState.appraisalResult.parts, rearRightMudguard: event.target.value }}}))} value={this.state.appraisalResult?.parts?.rearRightMudguard || 'original'}>
                          {this.state.partsStatus.map((part, index) =>
                            <option key={index} value={part.id}>{part.name}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-12">
                        <h5><strong>Ekspertiz Açıklaması<strong className="text-danger ml-1">*</strong></strong></h5>
                        <textarea className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({appraisalResult: {...prevState.appraisalResult, comment: event.target.value}}))} placeholder="Açıklama" type="email" value={this.state.appraisalResult?.comment || ''} />
                      </div>
                    </div>
                    <div className="text-row text-right mt-2">
                      <button className="btn bg-orange text-white" onClick={this.saveAuctionVehicleOnClick}><i className="fa fa-save"></i> Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionVehicleAdd(props) {
  return (
    <AuctionVehicleAddModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionVehicleAddModule>
  );
}
